export const INPUT_SIZES = {
	xs: '32px',
	sm: '40px',
	md: '42px',
	lg: '48px',
};
